import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import CompanyRegistrationHeader from '../components/Service/HrRecruitment/CompanyRegistrationHeader';
import CompanyRegistrationInfo from '../components/Service/HrRecruitment/CompanyRegistrationInfo';
import ConditionsForRegister from '../components/Service/HrRecruitment/ConditionsForRegister';
import RegistrationProcess from '../components/Service/HrRecruitment/RegistrationProcess';
import Share from '../components/Share';
import SideOverlap from './sideOverlap';

export default function CompanyRegistration() {
    return (
        <>
            <Header />
            <CompanyRegistrationHeader />
            <CompanyRegistrationInfo />
            <ConditionsForRegister />
            <RegistrationProcess />
            
            <Share />
            <Footer />
            <SideOverlap/>
        </>
    )
}
